<template>
  <div class="app">
    <section class="thick">
      <hospital-select @selected="selectHospital"></hospital-select>
      <section class="thick mythick" style="z-index: 10000">
        <div class="title" @click="showMapList">
          <span class="f-strong">{{ flowName }}</span>
          <div class="mytitle">
            <span v-show="!showDetailInfo" class="arr-gray-down"></span>
            <span v-show="showDetailInfo" class="arr-gray-up"></span>
          </div>
        </div>
        <div v-if="areaInfo.maps" v-show="showDetailInfo">
          <div v-for="map in areaInfo.maps" class="report-detail">
            <div class="field myfield" @click="selectMap(map)">
              <div>
                <label>{{ map.mapName }}</label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div v-show="hospitalImage != ''" class="hos-info-image">
        <img
          v-if="channel === 'WX'"
          :src="hospitalImage"
          style="width: 100%"
          id="inMapImg"
          alt=""
        />
        <vue-preview v-else :slides="slide"></vue-preview>
      </div>
    </section>
  </div>
</template>
<script>
import HospitalSelect from 'HospitalSelect'
import hospitals from 'hospital.service'
export default {
  components: {
    HospitalSelect,
  },
  data () {
    return {
      showDetailInfo: false,
      flowName: '',
      /*eslint-disable*/
      channel: localStorage.channel,
      areaInfo: {},
      hospitalImage: "",
      slide: []
    };
  },
  mounted () {
    this.refresh()
    /*eslint-disable*/
    $('#inMapImg').click(function () {
      var src = $(this).attr('src');
      var imgs = $(this).parent().parent().find('img');
      var list = new Array();
      for (var i = 0; i < imgs.length; i++) {
        list.push($(imgs[i]).attr('src'));
      }
      wx.previewImage({
        current: src, // 当前显示图片的http链接
        urls: list // 需要预览的图片http链接列表
      });
    });
  },
  methods: {
    refresh () {
      var areaId = JSON.parse(localStorage.selectedArea).areaId
      this.getAreaMap(areaId)
    },
    showMapList () {
      this.showDetailInfo = !this.showDetailInfo;
    },
    selectMap: function (map) {
      this.showDetailInfo = false
      this.flowName = map.mapName
      if (map.mapUrl === '') {
        this.hospitalImage = 'http://192.168.35.97/gateway/archive/resource/20181113/20181113132809.png' + '?t=' + Math.random();
        return
      }
      this.hospitalImage = map.mapUrl + '?t=' + Math.random();
      this.imgPreview()
    },
    getAreaMap: function (params) {
      hospitals.getInpatientMap({
        areaId: params
      }).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
        }
        this.areaInfo = res.data

        if (this.areaInfo.maps.length > 0) {
          //默认第一个楼层名称
          this.flowName = this.areaInfo.maps[0].mapName;
          if (this.areaInfo.maps[0].mapUrl === '') {
            this.hospitalImage = 'http://192.168.35.97/gateway/archive/resource/20181113/20181113132809.png' + '?t=' + Math.random();
            return
          }
          this.hospitalImage = this.areaInfo.maps[0].mapUrl + '?t=' + Math.random();
          this.imgPreview()
        }
      })
    },
    selectHospital () {
      this.$router.back();
    },
    //兼容市民云预览图片
    imgPreview () {
      this.slide = []
      let img = new Image()
      let newImage = {}
      img.src = this.hospitalImage;
      img.onload = () => {
        newImage.src = img.src;
        newImage.msrc = img.src;
        newImage.w = img.width;
        newImage.h = img.height;
        this.slide.push(newImage)
      }
    }
  },
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.hos-info-image {
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.scroll-height {
  margin-bottom: 1.8rem;
}
.mythick {
  margin-bottom: 0 !important;
}
.mytitle {
  float: right;
  padding-right: 0.5rem;
}
.myfield {
  background: #f8f8f8;
}

.my-gallery {
  width: 100%;

  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// InMap.vue?9a1ef83c